import React from 'react'
import { Routes, Route } from 'react-router-dom'
import 'antd/dist/reset.css'
import 'App.scss'
import Home from 'pages/Dashboard'
import ProductList from 'pages/Dashboard/ProductsList'
import ProductDetail from 'pages/Dashboard/ProductDetail'
import Chats from 'pages/Dashboard/Chats'
import AiChatBot from 'pages/Dashboard/Chats/AIChat'
import ChatsImage from 'pages/Dashboard/ChatsImage'
import AiChatBotImg from 'pages/Dashboard/ChatsImage/AIChat'
import User from 'pages/Dashboard/User'
import UserAccount from 'pages/Dashboard/UserAccount'
import Openai from 'pages/Dashboard/User/Openai'
import OpenaiDetail from 'pages/Dashboard/User/OpenaiDetail'
import Payment from 'pages/Dashboard/Payment'
import Checkout from 'pages/Dashboard/Payment/Checkout'
import FreeTrial from 'pages/Dashboard/Payment/FreeTrial'
import SelectedPlan from 'pages/Dashboard/Payment/SelectedPlan'
import { Profile, Security, Membership, Billing, Setting } from 'pages/Dashboard/UserAccount/component'
import LoginByToken from 'pages/Dashboard/LoginByToken'
import Affiliate from 'pages/Dashboard/Affiliate'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AiHub from 'pages/Dashboard/Chats/AIHub'
import AiChatHub from 'pages/Dashboard/Chats/AIChatHub'
import PaymentByCard from 'pages/Dashboard/Payment/PaymentByCard'
import CreditYour from 'pages/Dashboard/User/CreditYour'

const App: React.FC = () => {
  return (
    <>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/products' element={<ProductList />} />
        <Route path='/product/:slug' element={<ProductDetail />} />
        <Route path='/ai-hub' element={<AiHub />} />
        <Route path='/ai-chat' element={<Chats />} />
        <Route path='/ai-chat/:slug' element={<AiChatBot />} />
        <Route path='/ai-chat-hub' element={<AiChatHub />} />
        <Route path='/login-by-token' element={<LoginByToken />} />

        {/* <Route path='/user-account' element={<UserAccount />}>
        <Route path="profile" element={<Profile />}/>
        <Route path="security" element={<Security />} />
        <Route path="membership" element={<Membership />} />
        <Route path="billing" element={<Billing />} />
        <Route path="setting" element={<Setting />} />
      </Route> */ }

        <Route path="/user-account/:section?" element={<UserAccount />} />
        <Route path='/' element={<User />} />
        <Route path='/user-account' element={<UserAccount />} />
        <Route path='/user/ai-writer' element={<Openai />} />
        <Route path='/user/openai/:slug' element={<OpenaiDetail />} />
        <Route path='/ai-chat-images' element={<ChatsImage />} />
        <Route path='/ai-chat-images/:slug' element={<AiChatBotImg />} />
        <Route path='/payment' element={<Payment />} />
        <Route path='/checkout/:slug' element={<Checkout />} />
        <Route path='/payment/:slug' element={<FreeTrial />} />
        <Route path='/payment/selected-plan' element={<SelectedPlan />} />
        <Route path='/affiliate' element={<Affiliate />} />
        <Route path='/payment-by-card' element={<PaymentByCard />} />
        <Route path='/credit-your' element={<CreditYour />} />
      </Routes >
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  )
}

export default App
